// DataContext.js
import React, { createContext, useContext, useReducer, useEffect } from 'react';

const DataContext = createContext();

const initialState = {
    data: [],
    loading: true,
    error: null,
};

const dataReducer = (state, action) => {
    switch (action.type) {
        case 'FETCH_SUCCESS':
            return { ...state, data: action.payload, loading: false };
        case 'FETCH_ERROR':
            return { ...state, error: action.payload, loading: false };
        default:
            return state;
    }
};

const DataProvider = ({ children }) => {
    const [state, dispatch] = useReducer(dataReducer, initialState);

    useEffect(() => {
        fetch("https://www.devvcsappcloud.com/mtgroup/api/requisition/extractxmldataclient")
            .then(async (res) => {
                if (res.ok) {
                    const data = await res.json();
                    dispatch({ type: 'FETCH_SUCCESS', payload: data });
                } else {
                    const error = new Error('Failed to fetch data');
                    dispatch({ type: 'FETCH_ERROR', payload: error });
                }
            })
            .catch((error) => {
                dispatch({ type: 'FETCH_ERROR', payload: error });
            });
    }, []);

    return (
        <DataContext.Provider value={state}>
            {children}
        </DataContext.Provider>
    );
};

const useData = () => {
    const context = useContext(DataContext);
    if (!context) {
        throw new Error('useData must be used within a DataProvider');
    }
    return context;
};

export { DataContext, DataProvider, useData };



// WEBPACK FOOTER //
// ./src/DataContext.js